/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Operation } from '../../models/operation';
import { UserProfileDto } from '../../models/user-profile-dto';

export interface PatchUserProfile$Params {
  securityToken?: string;
  'X-API-Version'?: string;
      body: Array<Operation>
}

export function patchUserProfile(http: HttpClient, rootUrl: string, params: PatchUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfileDto>> {
  const rb = new RequestBuilder(rootUrl, patchUserProfile.PATH, 'patch');
  if (params) {
    rb.query('securityToken', params.securityToken, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserProfileDto>;
    })
  );
}

patchUserProfile.PATH = '/api/user-profile';
